import React from "react";
import Wanchain from "../../../assets/icons/Wanchain.svg";
import Wanchain1 from "../../../assets/icons/Wanchain_1.png";

function PowerdBy() {
  return (
    <div className="flex justify-center">
      <div className="flex  flex-col items-center">
        <div className="text-xs">Powered By</div>
        <div>
          <img src={Wanchain1} width={80}  alt="Wanchain1" />
        </div>
      </div>
    </div>
  );
}

export default PowerdBy;
